

const CategoryNav = () => {
    return ( 
        <div className="categoryNav">
            <a href="/">Movies</a>
            <a href="/">TV Shows</a>
        </div>
     );
}
 
export default CategoryNav;